const ArrowRightSvg = ( { className } ) => {
	return (
		<svg
			width="100%"
			viewBox="0 0 33 24"
			className={className}>
			<path
				// eslint-disable-next-line max-len
				d="M23.4105 14.4696H0.820984V9.39225H23.2755L18.0542 4.04829L21.6858 0.5L32.9219 12L21.6858 23.5L18.0542 19.9517L23.4105 14.4696Z"
				fill="currentColor"/>
		</svg>
	);
};
export default ArrowRightSvg;
